import DeviceProfileManageData from './DeviceProfileManageData';

export default DeviceProfileManageData;
